import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/MainPage/MainPage.tsx");
